module.exports = __webpack_public_path__ + "img/3076330-05-4.a8eb6361.png";